import { NotificationList } from 'components/dashboard/userNotifications';
import { GuidedTour } from 'components/shared/GuidedTour/GuidedTour';
import { useSyncUserCookieConsentWithStore } from 'hooks/use-user-cookie-consent';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import type { AppState } from 'state/state.model';
import { getContacts } from 'state/user';

import { AppHeader } from './main/sp-header';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useLocation();
  const isEssentialWorkspaceEnabled = useToggleFeature('essentialWorkspaceParis');

  const contactsConfig = useSelector((state: AppState) => getContacts(state));
  const contacts = JSON.stringify(contactsConfig);

  const isBorderlessFooter = ['/smart-quote', '/essential'].includes(pathname);

  useSyncUserCookieConsentWithStore();

  if (isEssentialWorkspaceEnabled) {
    return (
      <GuidedTour>
        <NotificationList />
        <div className="d-flex flex-column main-layout">
          <AppHeader />

          <div className="d-flex flex-column min-h-0 flex-grow-1" data-e2e="page-container">
            {children}
          </div>

          <div className="footer">
            <sgwt-mini-footer
              container="container-fluid"
              mode="sg-markets"
              type="micro"
              accessibility-compliance="partial"
              accessibility-link="accessibility.static.html"
              contact-us={contacts}
              // TODO : uncomment when doc is fixed
              // legal-notices={legalNotices}
              no-border={isBorderlessFooter ? 'true' : undefined}
            ></sgwt-mini-footer>
          </div>
        </div>
      </GuidedTour>
    );
  }

  return (
    <GuidedTour>
      <NotificationList />
      <div className="d-flex flex-column main-layout">
        <AppHeader />
        <div className="flex-grow-1 d-flex flex-column min-h-0">
          <div className="w-100 h-up-lg-100 min-h-down-lg-100 flex-grow-1" data-e2e="page-container">
            {children}
          </div>
        </div>
        <sgwt-mini-footer
          container="container-fluid"
          mode="sg-markets"
          type="micro"
          accessibility-compliance="partial"
          accessibility-link="accessibility.static.html"
          contact-us={contacts}
          // TODO : uncomment when doc is fixed
          // legal-notices={legalNotices}
          no-border={isBorderlessFooter ? 'true' : undefined}
        ></sgwt-mini-footer>
      </div>
    </GuidedTour>
  );
};
Layout.displayName = 'Layout';

// const legalNotices = JSON.stringify({
//   en: [
//     {
//       label: 'Notice to Investors',
//       value: 'https://docs.sgcib.com/Content/Resource/Key/SGM_LEGAL_NOTICE_TO_INVESTORS',
//     },
//   ],
//   fr: [
//     {
//       label: 'Notice Investisseurs',
//       value: 'https://docs.sgcib.com/Content/Resource/Key/SGM_LEGAL_NOTICE_TO_INVESTORS',
//     },
//   ],
// });
